import React, { useState, useEffect } from 'react';
import axios from "../../utils/axiosConfig";

const CURRENCIES = [
  { id: 1, name: 'USD' },
  { id: 2, name: 'Pound' },
  { id: 3, name: 'Euro' },
];

const MONTHS = [
  'April', 'May', 'June', 'July', 'August', 'September',
  'October', 'November', 'December', 'January', 'February', 'March'
];

const ForexRateMaster = () => {
  const [activeTab, setActiveTab] = useState("rates");
  const [year, setYear] = useState('2025-2026');
  const [rates, setRates] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchRates(year);
  }, [year]);

  const fetchRates = async (year) => {
    try {
      const res = await axios.get(`${"/forex-rates"}/${year}`);
      const mapped = {};

      res.data.forEach(r => {
        const currency = CURRENCIES.find(c => c.id === r.Currency_Id)?.name;
        mapped[`${currency}-${r.Month}`] = r.Rate;
      });

      setRates(mapped);
      setDataLoaded(res.data.length > 0);
    } catch (err) {
      setDataLoaded(false);
      alert('Failed to load rates');
    }
  };

  const handleRateChange = (currency, month, value) => {
    const key = `${currency}-${month}`;
    setRates(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    const data = [];

    for (let c of CURRENCIES) {
      for (let m of MONTHS) {
        const key = `${c.name}-${m}`;
        const rate = parseFloat(rates[key] || 0);
        data.push({ Currency_Id: c.id, Month: m, Rate: rate });
      }
    }

    try {
      await axios.post("/forex-rates", { year, rates: data });
      alert("Rates saved successfully");
      fetchRates(year);
    } catch (err) {
      alert("Save failed: " + err.message);
    }
  };

  return (
    <div className="container mt-3">

      <div className="mb-3">
        <h4 className="fw-bold">💱 Forex Rate Master</h4>
      </div>

      <div className="card shadow-sm border-0">

        {/* Header Tabs */}
        <div className="card-header bg-white">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "rates" ? "active" : ""}`}
                onClick={() => setActiveTab("rates")}
              >
                Manage Rates
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body">

          {/* Year Selector */}
          <div className="row mb-3 align-items-center">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Financial Year</label>
              <select
                className="form-select"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                <option value="2024-2025">2024-2025</option>
                <option value="2025-2026">2025-2026</option>
                <option value="2026-2027">2026-2027</option>
              </select>
            </div>

            <div className="col-md-6 mt-4">
              {dataLoaded ? (
                <span className="text-success fw-semibold">
                  ✅ Rates loaded for {year}
                </span>
              ) : (
                <span className="text-warning fw-semibold">
                  🆕 New entry for {year}
                </span>
              )}
            </div>
          </div>

          {/* Rates Grid */}
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Month</th>
                  {CURRENCIES.map(c => (
                    <th key={c.id}>{c.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {MONTHS.map(month => (
                  <tr key={month}>
                    <td className="fw-semibold">{month}</td>
                    {CURRENCIES.map(c => (
                      <td key={`${c.name}-${month}`}>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          value={rates[`${c.name}-${month}`] || ''}
                          onChange={(e) =>
                            handleRateChange(c.name, month, e.target.value)
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Save Button */}
          <div className="text-end mt-3">
            <button
              className="btn btn-success"
              onClick={handleSave}
            >
              💾 Save Rates
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ForexRateMaster;